/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Col, Modal, Row, Tooltip, Spin, Form, Input, Button, message } from "antd";
import { CaretDownOutlined, CaretRightOutlined, ExclamationCircleOutlined, FileZipOutlined, FolderFilled, FolderOpenOutlined, InfoCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { IoIosCreate } from "react-icons/io";
import {  MdOutlineUploadFile } from "react-icons/md";
import {  shallowEqual, useDispatch, useSelector } from "react-redux";
import { transactionLaneDataHandle } from "../state/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import styles from "../style/DoraDocument.module.css";
import { useMediaQuery } from "react-responsive";
import DoraDocLegendModal from "./DoraDocLegendModal";
import { formatPhoneNumber, getCoAgentsIds, getStreetAddress } from "../../Common/utils/universalFuntions";
import { removePersonObject } from "../../Common/utils/universalFuntions";
import { checkIfDisabled, customerDocsContractTypes, disabledTransactionText, listingContractTypes } from "../../Common/commondata/commonData";
import _ from "lodash";
import UploadPdfDoc from "./UploadPdfDoc";
import { getCityFromFullAddress, getFullNamesFromArray } from "../../Common/utils/ExtraFunctions";
import { getBuildDataForCustomerdocs } from "../../OfferTable/utils/helper";
import { prepareCurrentAgentDetails } from "../utils/rtdHepler";

const StyledTree = styled.div`
  line-height: 1.5;
  width: 100%;
`;
const StyledFile = styled.div`
  padding-left: px;
  display: flex;
  align-items: center;
  span {
    margin-left: 0px;
  }
`;
const StyledFolder = styled.div`
  padding-left: 0px;
  .folder--label {
    display: flex;
    align-items: center;
    span {
      margin-left: 0px;
    }
`;
const Collapsible = styled.div`
  height: ${(p) => (p.isOpen ? "0" : "auto")};
  overflow: hidden;
`;

const Folder = ({ name, children, selectedData, fiters, isSmallScreen, isMediumScreen }) => {
  const [isOpen, setIsOpen] = useState(fiters?.search ? true : false);

  const handleToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const archivedOrTerminated = selectedData?.status === "TERMINATED";
  return (
    <StyledFolder>
      <div
        className="folder--label"
        onClick={handleToggle}
        style={{
          cursor: "pointer",
          pointerEvents: archivedOrTerminated ? "none" : "pointer",
          alignItems: "baseline",
        }}
      >
        {isOpen ? (
          <>
            <CaretDownOutlined
              style={{
                fontSize: "1.3rem",
                marginRight: "5px",
                color: archivedOrTerminated ? "#b0b0b0" : "rgb(107,152,199)",
              }}
            />{" "}
            <FolderOpenOutlined style={{ fontSize: "20px", color: "rgb(107,152,199)" }} />
          </>
        ) : (
          <>
            <CaretRightOutlined style={{ fontSize: "1.3rem", color: "#8C8C8C" }} />
            <FolderFilled
              style={{
                fontSize: isSmallScreen ? "14px" : isMediumScreen ? "16px" : "20px",
                color: archivedOrTerminated ? "#b0b0b0" : "rgb(107,152,199)",
                // marginLeft: "14px",
              }}
            />
          </>
        )}
        <span
          style={{
            fontSize: isSmallScreen ? "14px" : isMediumScreen ? "16px" : "20px",
            fontWeight: 600,
            color: "#8C8C8C",
            marginTop: "4px",
            paddingLeft: "4px",
          }}
        >
          {name}
        </span>
      </div>
      <Collapsible isOpen={!isOpen}>{children}</Collapsible>
    </StyledFolder>
  );
};
const File = ({ doraDocItem, selectedData, getTransactionLaneData, insideFolder, userAuthKey, isSmallScreen, isMediumScreen, offerId }) => {
  let dispatch = useDispatch();
  const { URLofferTableJSON, isAccpetedOfferPresent, checkForDisable, currentSellerAgentData } = useSelector((state) => state.offerTable);
  const {doraDocsUrlShorthandLoading} = useSelector((state) => state.rtdTransactionLane, shallowEqual);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [allData, setAllData] = useState({
    uploadPdfDoc: false,
    file: "",
  });
  const { getIndividualTransactionData } = useSelector((state) => state.rtdTransactionLane);
   const currentAgentDetails = getIndividualTransactionData?.currentAgentId;
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const history = useHistory();
  const handleCreateNew = (doraDocItem) => {
    if ((doraDocItem?.contractType === "TO" || doraDocItem?.contractType === "CI") && !getIndividualTransactionData?.titleCompanyDetails?.selectedBy) {
      message.error("Please select/add a Title Company to proceed with the following document!");
      return;
    }
    if (doraDocItem?.contractType === "INSP_RESOL" && getTransactionLaneData?.filter((el) => el?.contractType === "INSP_OBJ")?.length <= 0) {
      Modal.confirm({
        title: "Warning! An inspection objection document should exist before creating an inspection resolution document! Are you sure you want to proceed?",
        okText: "Yes",
        cancelText: "No",
        icon: <ExclamationCircleOutlined />,
        onOk: () => {
          urlShortHand(doraDocItem);
        },
        onCancel: () => {
          handleCancel();
        },
      });
    } else {
      urlShortHand(doraDocItem);
    }
  };
  const urlShortHand = (ele) => {
    try {
      const officeDetails = {
        officeLogo: currentSellerAgentData?.brokerageData?.brokerageLogo || currentSellerAgentData?.brokerageData?.brokerageId?.logo || "",
        name: currentSellerAgentData?.brokerageData?.brokerageName?.trim() || "",
        address: currentSellerAgentData?.brokerageData?.brokerageAddress || "",
        agentId: currentSellerAgentData?._id,
      };
      const transactionData = getIndividualTransactionData?.newTransactionData || {};
      if (customerDocsContractTypes.includes(ele?.contractType)) {
        const buildData = getBuildDataForCustomerdocs({ contractType: ele?.contractType, contractId: ele.contractId, currentSellerAgentData, transactionData, getIndividualTransactionData, item: { isProperty: "SELLER" }, officeDetails, userAuthKey });
        dispatch(transactionLaneDataHandle.doraDocsUrlShorthandApiCalling({ buildData, history }));
        return;
      }
      let commonBuildData = {
        builtForId: currentAgentDetails?._id,
        key: currentAgentDetails?._id,
        builtForSection: "DOCUMENT",
        signable: true,
        openFor: "SELLER_AGENT",
        contractId: ele.contractId,
        contractType: ele.contractType,
        offerId: getIndividualTransactionData?.offerId,
        propertyId: URLofferTableJSON?.propertyId,
        token: userAuthKey,
        RTDInitiator: "SELLER",
      };
      let buildData = {
        ...commonBuildData,
        buyerAgentIds: getCoAgentsIds(getIndividualTransactionData?.buyerAgentIds),
        sellerAgentIds: getCoAgentsIds(getIndividualTransactionData?.sellerAgentIds),
        urlData: {
          ...(getIndividualTransactionData?.newTransactionData || {}),
          Sellers: removePersonObject(getIndividualTransactionData?.sellerIds),
          ...(ele?.prefillValues || {}),
          ...((ele?.contractType === "CI" || ele?.contractType === "TO") && getIndividualTransactionData?.titleCompanyDetails
            ? {
                TitleCompanyLogo: getIndividualTransactionData?.titleCompanyDetails?.titleCompanyLogo || "",
                TitleCompanyName: getIndividualTransactionData?.titleCompanyDetails?.titleCompanyName || "",
                TitleOfficeName: getIndividualTransactionData?.titleCompanyDetails?.titleOfficeName || "",
                TitleOfficeEmail: getIndividualTransactionData?.titleCompanyDetails?.titleOfficeEmail || "",
                TitleOfficeAddress: getIndividualTransactionData?.titleCompanyDetails?.titleOfficeAddress || "",
                TitleOfficePhoneNo: getIndividualTransactionData?.titleCompanyDetails?.titleOfficePhoneNo || "",
                TitleOfficeFaxNo: getIndividualTransactionData?.titleCompanyDetails?.titleOfficeFaxNo || "",
                TitleCloserName: getIndividualTransactionData?.titleCompanyDetails?.titleCloserName || "",
                TitleCloserEmail: getIndividualTransactionData?.titleCompanyDetails?.titleCloserEmail || "",
                SalesRepName: getIndividualTransactionData?.titleCompanyDetails?.salesRepName || "",
                SalesRepEmail: getIndividualTransactionData?.titleCompanyDetails?.salesRepEmail || "",
              }
            : {}),
          ...(["SA", "CB_NOCOLS"].includes(ele?.contractType)
            ? {
                BrokerName: currentSellerAgentData?.fullName || "",
                BrokerEmailAddress: currentSellerAgentData?.email || "",
                BrokerFirmName: currentSellerAgentData?.brokerageData?.name || "",
                BrokerFirmAddress: currentSellerAgentData?.brokerageData?.address || "",
                BrokerPhoneNumber: formatPhoneNumber(currentSellerAgentData?.mobilePhoneNumber?.phoneNumber),
                BrokerFaxNumber: formatPhoneNumber(currentSellerAgentData?.brokerageData?.faxNumber),
              }
            : {}),
          ...(["CRE_RE", "CRE_LA"].includes(ele?.contractType)
            ? {
                StreetAddress: getStreetAddress(selectedData?.address),
                City: getCityFromFullAddress(selectedData?.address),
                ...(ele?.contractType === "CRE_RE" && { BuyerBrokersList: getFullNamesFromArray(selectedData?.buyerAgentIds) }),
                ...(ele?.contractType === "CRE_LA" && { SellerBrokersList: getFullNamesFromArray(selectedData?.sellerAgentIds) }),
              }
            : {}),
          officeDetails,
        },

        ...((ele?.contractType === "CI" || ele?.contractType === "TO") && getIndividualTransactionData?.titleCompanyDetails
          ? {
              titleCompanyDetails: {
                inBuilt: getIndividualTransactionData?.titleCompanyDetails?.inBuilt,
                selectedBy: getIndividualTransactionData?.titleCompanyDetails?.selectedBy,
                ...(getIndividualTransactionData?.titleCompanyDetails?.titleOfficeId ? { titleOfficeId: getIndividualTransactionData?.titleCompanyDetails?.titleOfficeId } : {}),
                ...(getIndividualTransactionData?.titleCompanyDetails?.salesRepId ? { salesRepId: getIndividualTransactionData?.titleCompanyDetails?.salesRepId } : {}),
                ...(getIndividualTransactionData?.titleCompanyDetails?.titleCloserId ? { titleCloserId: getIndividualTransactionData?.titleCompanyDetails?.titleCloserId } : {}),
              },
            }
          : {}),
      };
      if (["CB_SAEFPT", "DC_TAC"].includes(ele.contractType)) {
        buildData.urlData.Buyers = [];
        buildData.urlData.Sellers = [];
      }

      if (["DC_ADBA", "DC_BCLA", "DC_CLASLC"].includes(ele?.contractType)) {
        const { agentArray } = prepareCurrentAgentDetails({ currentAgentDetails, contractType: ele?.contractType });
        delete buildData.buyerAgentIds;
        delete buildData.sellerAgentIds;
        if (ele.contractType === "DC_ADBA") {
          buildData.urlData.BuyerAgents = [];
          buildData.urlData.SellerAgents = agentArray;
        } else {
          buildData.urlData.BuyerAgents = transactionData.BuyerAgents?.slice(0, 2) ?? [];
          buildData.urlData.SellerAgents = ele.contractType === "DC_CLASLC" ? agentArray : transactionData.SellerAgents?.slice(0, 2) ?? [];
        }
      }
      return dispatch(transactionLaneDataHandle.doraDocsUrlShorthandApiCalling({ buildData, history }));
    } catch (error) {
      console.log("error while creating a new document", error);
    }
  };

  const handleCreateDoraDoc = () => {
    setIsModalVisible(true);
  };

  let docInRtd = false;
  getTransactionLaneData?.forEach((el) => {
    if (el.contractType === doraDocItem.contractType) {
      docInRtd = true;
    }
  });
  const handleUploadNew = () => {
    setAllData({
      ...allData,
      uploadPdfDoc: true,
    });
  };

  const handleModalCancel = () => {
    setAllData({
      ...allData,
      uploadPdfDoc: false,
    });
  };

  const disbleCOCondition = URLofferTableJSON?.urlData?.sellerOpenOfferTable || selectedData?.data?.offerStatus === "TERMINATED" || checkForDisable?.disabled;
  const notshowToolTip = URLofferTableJSON?.urlData?.sellerOpenOfferTable || selectedData?.data?.offerStatus === "TERMINATED" || checkForDisable?.disabled;

  const offerDisabled = checkForDisable?.disabled || (checkIfDisabled({ openFor: "SELLER_AGENT", sellingStatus: selectedData?.data?.offerStatus }))?.disabled;
  return (
    <StyledFile
      style={{
        pointerEvents: listingContractTypes.includes(doraDocItem?.contractType) ? "none" : "auto",
        opacity: listingContractTypes.includes(doraDocItem?.contractType) ? 0.6 : 1,
      }}
    >
      {/* <Tooltip title={isAccpetedOfferPresent && !notshowToolTip && (doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO") ? <span style={{ fontSize: isSmallScreen ? 10 : isMediumScreen ? 12 : 14 }}>Accepted Offer Exists: Cannot Create This Document</span> : ""}> */}
      <span
        style={{
          fontSize: isSmallScreen ? "14px" : isMediumScreen ? "16px" : "18px",
          fontWeight: 500,
          color: disbleCOCondition && (doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO") ? "#b0b0b0" : docInRtd ? "rgb(110 153 214)" : "#8C8C8C",
          width: "100%",
          marginTop: "4px",
          marginLeft: insideFolder ? "21px" : "auto",
          paddingLeft: 0,
          cursor: notshowToolTip ? "not-allowed" : isAccpetedOfferPresent ? "context-menu" : "pointer",
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        {doraDocItem.name && (
          <FileZipOutlined
            className={disbleCOCondition || notshowToolTip ? "" : styles.fileContainer}
            style={{
              fontSize: isSmallScreen ? "14px" : isMediumScreen ? "16px" : "20px",
              marginRight: "5px",
              flexShrink: 0,
            }}
          />
        )}

        <span
          className={(doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO") && (disbleCOCondition || notshowToolTip) ? "" : styles.fileContainer}
          {...(offerDisabled ? { onClick: disabledTransactionText } : { onClick: () => ((doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO") && (disbleCOCondition || notshowToolTip) ? {} : handleCreateDoraDoc()) })}
          style={{
            wordBreak: "break-word",
            display: "inline-block",
          }}
        >
          {doraDocItem.name}
        </span>
      </span>
      {/* </Tooltip> */}

      <UploadPdfDoc selectedData={{ ...selectedData, ...doraDocItem, RTDInitiator: "SELLER" }} allData={allData} setAllData={setAllData} handleModalCancel={handleModalCancel} open={allData?.uploadPdfDoc} getCoordinateItem={{ isProperty: "SELLER" }} setIsModalVisible={setIsModalVisible} offerId={offerId} />
      <Modal visible={isModalVisible} onCancel={handleCancel} footer={[]} style={{ height: "300px" }}>
        {selectedData?.propertyYearBuilt > 1977 && (doraDocItem.contractType === "LBPOS" || doraDocItem.contractType === "LBPD") && (
          <p style={{ fontWeight: "500", color: "#2976be" }}>
            Note : <text style={{ fontWeight: "500", color: "darkgray" }}>Document Not Required ! This property was built after 1977, exempting the need for this document.</text>{" "}
          </p>
        )}
        {doraDocsUrlShorthandLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30vh",
            }}
          >
            <Spin />
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              gap: "5px",
              width: "51%",
              margin: "auto",
              paddingLeft: "30px",
            }}
          >
            <p
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontSize: "20px",
                color: "#2976be",
                cursor: "pointer",
              }}
              onClick={() => handleCreateNew(doraDocItem)}
            >
              <IoIosCreate size={25} /> Create New
            </p>
            <p
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                fontSize: "20px",
                color: doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO" ? "#ccc" : "#2976be",
                cursor: doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO" ? "not-allowed" : "pointer",
                pointerEvents: doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO" ? "none" : "auto",
              }}
              onClick={doraDocItem?.contractType === "CO" || doraDocItem?.contractType === "MH_CO" ? null : handleUploadNew}
            >
              <MdOutlineUploadFile size={25} /> Upload PDF
            </p>
          </div>
        )}
      </Modal>
    </StyledFile>
  );
};

const Tree = ({ children }) => {
  return <StyledTree>{children}</StyledTree>;
};

Tree.File = File;
Tree.Folder = Folder;
export default function DoraDocument({ selectedData, seller, userAuthKey, offerId }) {
  const isSmallScreen = useMediaQuery({ maxWidth: 550 });
  const isMediumScreen = useMediaQuery({ minWidth: 551, maxWidth: 850 });

  const { getDoraDocumentsData, getTransactionLaneData, getDoraDocumentsLoading } = useSelector((state) => state.rtdTransactionLane);
  const { offerTableAuthKey } = useSelector((state) => state.offerTable);
  const [showLegendModal, setShowLegendModal] = useState(false);
  const [doraDocsData, setDoraDocsData] = useState([]);
  const [fiters, setFilters] = useState({ search: "" });
  const [form] = Form.useForm();
  let dispatch = useDispatch();
  useEffect(() => {
    if (Array.isArray(getTransactionLaneData) && Array.isArray(getDoraDocumentsData)) {
      const foundMH = getTransactionLaneData.some((el) => el.contractType === "CBS_MH");
      const newData = getDoraDocumentsData.filter((el) => (foundMH ? el.contractType !== "CO" : el.contractType !== "MH_CO"));
      setDoraDocsData(newData);
    }
  }, [getTransactionLaneData, getDoraDocumentsData, fiters]);

  useEffect(() => {
    let data = {
      listType: seller,
      offerId: selectedData?.offerId,
    };
    dispatch(transactionLaneDataHandle.getDoraDocumentsData(data, offerTableAuthKey, fiters));
  }, [fiters]);

  const handleClear = ({ renderWithClear }) => {
    form.resetFields();
    setFilters({
      search: "",
    });
  };
  //debounce logic to call search api
  const debouncedFunction = _.debounce((value) => {
    setFilters({
      search: value,
    });
  }, 1000);

  const handleSearch = (event) => {
    const value = event.target.value;
    debouncedFunction(value);
  };
  return (
    <>
      {showLegendModal && <DoraDocLegendModal showLegendModal={showLegendModal} setShowLegendModal={setShowLegendModal} />}

      <Row className={styles.DoraDocumentContainer}>
        <Col style={{ width: "100%" }}>
          <div className={styles.doraDocHeading}>
            <h3>Forms</h3>
            <div>
              <Tooltip title="Legend" placement="right">
                <InfoCircleOutlined
                  onClick={() => setShowLegendModal(true)}
                  style={{
                    fontSize: isSmallScreen ? "18px" : isMediumScreen ? "20px" : "25px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    color: "hsl(209deg 72% 51%)",
                  }}
                />
              </Tooltip>
            </div>
          </div>
        </Col>
        <Row style={{ width: "100%", flexWrap: "nowrap", justifyContent: "center", gap: 5 }}>
          <Col className={styles.searchInputBoxCol}>
            <div className={styles.searchInputBox}>
              <Form form={form} initialValues={{}}>
                <Form.Item name="search">
                  <Input allowClear placeholder="Search here..." suffix={<SearchOutlined />} size="middle" onChange={handleSearch} />
                </Form.Item>
              </Form>
            </div>
          </Col>
          <Col>
            <div className={styles.sortBox}>
              <Button
                style={{
                  background: "#3a74b6",
                  color: "whitesmoke",
                  fontWeight: "bold",
                  border: "none",
                  padding: "0 10px",
                }}
                onClick={handleClear}
              >
                <div>Reset</div>
              </Button>
            </div>
          </Col>
        </Row>
        {getDoraDocumentsLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center", 
              alignItems: "center", 
              width: "100%",
              height: "50vh",
            }}
          >
            <Spin />
          </div>
        ) : (
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-start",
              overflowY: "auto",
              height: "calc(100vh - 14rem)",
              paddingTop: "10px",
              width: "100%",
            }}
          >
            <Tree>
              {doraDocsData?.map((item) => {
                return item?.doc_second?.length > 0 ? (
                  <Tree.Folder key={item._id} name={item?.name} style={{ cursor: "pointer" }} getTransactionLaneData={getTransactionLaneData} fiters={fiters} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen}>
                    {item?.doc_second?.map((element) => (
                      <Tree.File key={element._id} doraDocItem={element} selectedData={selectedData} seller={seller} getTransactionLaneData={getTransactionLaneData} insideFolder={true} userAuthKey={userAuthKey} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} offerId={offerId} />
                    ))}
                  </Tree.Folder>
                ) : (
                  <Tree.File key={item._id} doraDocItem={item} selectedData={selectedData} seller={seller} getTransactionLaneData={getTransactionLaneData} insideFolder={false} userAuthKey={userAuthKey} isSmallScreen={isSmallScreen} isMediumScreen={isMediumScreen} offerId={offerId} />
                );
              })}
            </Tree>
          </Col>
        )}
      </Row>
    </>
  );
}
